import { DialogResultStatus } from './dialogResultStatus';

export class DialogResult {
  status: DialogResultStatus;
  data: any;
}
